export const saveSlice = (arr, start?, end?) => (arr === null ? null : arr.slice(start, end));

export const isUndefined = (obj) => typeof obj === 'undefined';

export const isNull = (obj) => obj === null;

export const isUndefinedOrNull = (obj) => isUndefined(obj) || isNull(obj);

export const isArray = (arr) => arr instanceof Array;

export const s4 = (value?) => {
  var part = (Math.random().toString(16) + '000000000').substr(2, 8);

  return value ? '-' + part.substr(0, 4) + '-' + part.substr(4, 4) : part;
};

export const newGuid = () => s4() + s4(true) + s4(true) + s4();

export const isEqual = (object, object2) => {
  if (Object.keys(object).length != Object.keys(object2).length) return false;

  for (let key in object) {
    if (object.hasOwnProperty(key) && object2.hasOwnProperty(key)) {
      if (object[key] !== object2[key]) {
        return false;
      }
    }
  }

  return true;
};

export const encodeQueryData = (data) => {
  const ret = [];

  for (let d in data) {
    if (data.hasOwnProperty(d)) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    }
  }

  return ret.join('&');
};

export const getJsonFromUrl = (query) => {
  if (query) {
    return {};
  }

  var result = {};

  query.split('&').forEach((part) => {
    var item = part.split('=');

    result[item[0]] = decodeURIComponent(item[1]);
  });

  return result;
};

export const saveProp = (obj, key, value?) => {
  if (isUndefined(value)) {
    value = '';
  }

  if (isUndefined(obj)) {
    return value;
  }

  return isUndefined(obj[key]) ? value : obj[key];
};

// TODO For example
declare global {
  interface StringConstructor {
    format(args): any;
  }

  interface Array<T> {
    isSc(): boolean;
  }

  interface Window {
    seyHi(): any;
  }
}

window.seyHi = () => {
  return 'Hi';
};

String.format = (args) => {
  return args;
};

Array.prototype.isSc = () => {
  return true;
};

export const isSafari = () => {
  return navigator.userAgent.indexOf('safari') != -1 && !(navigator.userAgent.indexOf('chrome') > -1);
};
export const isChrome = () => {
  return navigator.userAgent.indexOf('safari') != -1 && navigator.userAgent.indexOf('chrome') > -1;
};
export const isFirefox = () => {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
};
export const isIE = () => {
  //TODO:
  return /*@cc_on!@*/ false || !!document['documentMode']; //!!navigator.userAgent.match(/Trident\/7\./);
};
export const isEdge = () => {
  // http://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser/9851769#9851769
  return !isIE && !!window['StyleMedia'];
};
export const isIE9andLess = () => {
  return document.all && !window.atob;
};

export const spliceSlice = function (text, index, count, add?) {
  // TODO
  // We cannot pass negative indexes directly to the 2nd slicing operation.
  if (index < 0) {
    index = text.length + index;

    if (index < 0) {
      index = 0;
    }
  }

  //return this.slice(0, index) + (add || "") + this.slice(index + count);
  return text.substring(index, index + count);
};

export const parseInt = function (value) {
  return Number.parseInt(value);
};

export const screenTabletSize = 1023;

export const _tr = (value) => {
  return value;
};

// It has only spaces, or is empty
export const onlySpacesOrEmpty = function (str) {
  return /^ *$/.test(str);
};

// It has only whitespace
export const hasOnlyWhitespace = function (str) {
  return /^ *$/.test(str);
};

export const hasWhiteSpace = function (s) {
  return /\S/.test(s);
};
